import React, { useState, useEffect } from 'react';
import { string, bool } from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import { getCookie } from 'helpers/cookies';

import Desktop from 'components/Navbar/Desktop';
import Mobile from 'components/Navbar/Mobile';

import { Container, Logo } from 'components/Navbar/NavbarStyles';

import ImgLogoColor from 'images/logo-full-color.svg';
import ImgLogoWhite from 'images/logo-full-filled-white.svg';

const Navbar = ({ createAccount, colors }) => {
  const [isSignedIn, setIsSignedIn] = useState(undefined);

  useEffect(() => {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      // The `unsafe_logged_in` cookie is set via Kong if a user is signed in.
      setIsSignedIn(!!getCookie('unsafe_logged_in'));
    }
  }, []);
  const data = useStaticQuery(graphql`
    query NavigationQuery {
      navigation(id: { ne: "dummy" }) {
        course_count
        career_track_count
        skills_track_count
        instructor_count
        featured_courses {
          title
          slug
        }
        featured_tracks {
          title_with_subtitle
          category
          slug
        }
        featured_instructors {
          full_name
          slug
        }
      }
    }
  `);
  return (
    <Container>
      <Logo href="/">
        <img
          alt="DataCamp"
          src={colors === 'darkOnLight' ? ImgLogoColor : ImgLogoWhite}
          width={169}
        />
      </Logo>
      {typeof isSignedIn !== 'undefined' && (
        <Mobile
          createAccount={createAccount}
          isSignedIn={isSignedIn}
          navigationInfo={data.navigation}
        />
      )}
      {typeof isSignedIn !== 'undefined' && (
        <Desktop
          colors={colors}
          createAccount={createAccount}
          isSignedIn={isSignedIn}
          navigationInfo={data.navigation}
        />
      )}
    </Container>
  );
};

Navbar.defaultProps = {
  colors: null,
  createAccount: false,
};

Navbar.propTypes = {
  colors: string,
  createAccount: bool,
};

export default Navbar;
